@let traductions = referentiel().metadonnees.traductions;
<form class="gap-lg grid" [formGroup]="form">
  <div hlmField>
    <label hlmFieldLabel for="select-famille">{{ traductions.familleDeLivrables }}</label>
    <hlm-select id="select-famille" #selectReferentiel formControlName="idFamilleLivrables">
      <hlm-select-trigger>
        <hlm-select-value />
      </hlm-select-trigger>

      <hlm-select-content>
        @for (famille of familles(); track famille.id) {
          <hlm-option [value]="famille.id">
            {{ famille.nom }}
          </hlm-option>
        }
      </hlm-select-content>
    </hlm-select>
  </div>

  <div hlmField>
    <label hlmFieldLabel for="input-nom" labelRequired>Nom du {{ traductions.livrable }}</label>
    <input id="input-nom" hlmInput type="text" formControlName="nom" />
    @if (nom.hasError('required')) {
      <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
    }
    @if (form.get('nom')?.hasError('notUnique')) {
      <hlm-field-error>Ce {{ traductions.livrable }} existe déjà.</hlm-field-error>
    }
  </div>
</form>
